module.exports = __webpack_public_path__ + "img/26-chrysler-pacifica.60e95643.jpg";